module.exports = __webpack_public_path__ + "img/icon-pregnancy.f57e56d5.png";